import colors from '@hl/ui-components/styles/colors.scss';

import { IAppTheme } from './IAppTheme';

/**
 * Light Theme
 * @type {IAppTheme}
 */
const lightTheme = (): IAppTheme => ({
  color: {
    chatPanel: colors.darkestGray,
    chatPanelBG: colors.white,

    chatBg: colors.white,
    chatBorder: colors.medGray,
    chatHeading: colors.darkestGray,

    betaBadge: colors.white,
    betaBadgeBG: colors.darkestGray,

    assistantMessageBG: colors.white,
    assistantMessage: colors.darkestGray,

    userMessageBG: '#E1EEFB',
    userMessage: colors.darkestGray,

    reaction: colors.medBlue,
    reactionActive: colors.hlOrange,

    messageInputButton: colors.medGray,

    retryButton: '#236FB9',

    errorLink: '#236FB9',
    errorLinkHover: '',
    errorIcon: colors.redOrange,

    loadingEllipses: colors.hlOrange,
  },
  font: {
    size: {
      small: '12px',
      default: '16px',
      medium: '18px',
      large: '24px',
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
  },
});

/**
 * Dark Theme
 * @type {IAppTheme}
 */
const darkTheme = (): IAppTheme => ({
  color: {
    chatPanel: colors.darkestGray,
    chatPanelBG: 'transparent',

    chatBg: colors.white,
    chatBorder: colors.medGray,
    chatHeading: colors.darkestGray,

    betaBadge: colors.white,
    betaBadgeBG: colors.darkestGray,

    assistantMessageBG: '#E8E8E8',
    assistantMessage: colors.darkestGray,

    userMessageBG: colors.medBlue,
    userMessage: colors.white,

    reaction: colors.medGray,
    reactionActive: colors.hlOrange,

    messageInputButton: colors.medGray,

    retryButton: colors.brightBlue,

    errorLink: colors.brightBlue,
    errorLinkHover: '',
    errorIcon: colors.redOrange,

    loadingEllipses: colors.medGray,
  },
  font: {
    size: {
      small: '12px',
      default: '16px', 
      medium: '18px',
      large: '24px', 
    },
    weight: {
      light: 300,
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
  },
});

/**
 * Theme Object
 * @type {{light: IAppTheme, dark: IAppTheme}}
 */
export const appTheme = (): { light: IAppTheme; dark: IAppTheme } => ({
  light: lightTheme(),
  dark: darkTheme(),
});
